import { Box } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import TaskActions from '../TaskActions';
import TaskContent from '../TaskContent';
import { TaskData, TaskActionData, ContentType, ActionType } from '../types';

interface TaskItemProps {
  data: TaskData & TaskActionData;
  contentType: ContentType;
  actionType: ActionType;
  onAction: (data: TaskData & TaskActionData) => void;
  onSkip?: (data: TaskData & TaskActionData) => void;
  paddingVertical: '2' | '4';
}

function TaskItem({
  data,
  contentType,
  actionType,
  onAction,
  onSkip,
  paddingVertical,
}: TaskItemProps) {
  const handleClick =
    actionType === 'recommendation' ? () => onAction(data) : undefined;

  return (
    <DataList.Row key={data.id} gap="1" padding="none" onClick={handleClick}>
      <Box
        display="flex"
        justifyContent="space-between"
        paddingBottom={paddingVertical}
        paddingTop={paddingVertical}
        paddingLeft="4"
        paddingRight="4"
      >
        <TaskContent
          data={data}
          contentType={contentType}
          actionType={actionType}
          onAction={onAction}
        />
        <Box display="flex" justifyContent="center">
          <TaskActions
            data={data}
            actionType={actionType}
            onAction={onAction}
            onSkip={onSkip}
          />
        </Box>
      </Box>
    </DataList.Row>
  );
}

export default TaskItem;
